(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ck5/ckeditor5"));
	else if(typeof define === 'function' && define.amd)
		define(["@ck5/ckeditor5"], factory);
	else if(typeof exports === 'object')
		exports["CKEditor"] = factory(require("@ck5/ckeditor5"));
	else
		root["CKEditor"] = factory(root["@ck5/ckeditor5"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 